// extracted by mini-css-extract-plugin
module.exports = {"mainBreadcrumb":"breadcrumbs_mainBreadcrumb__hkk1L","listStyleBreadcrumbs":"breadcrumbs_listStyleBreadcrumbs__hOC_o"};